<template>
  <svg xmlns="http://www.w3.org/2000/svg" v-bind:width="width" v-bind:height="height"
       v-bind:viewbox="'0 0 ' + (2 * radius) + ' ' + (2 * radius)">
    <g data-z-index="0">
      <path v-for="(path, i) in paths" v-bind:key="i" v-bind:fill="path.color" v-bind:stroke="backgroundColor" stroke-width="1"
            v-bind:d="path.d"></path>
      <circle v-bind:cx="radius" v-bind:cy="radius" v-bind:r="radius / 2" v-bind:fill="backgroundColor"/>
      <path v-bind:fill="textColor" v-bind:d="path" v-bind:stroke="backgroundColor" stroke-width="1"
            v-bind:transform="'rotate(' + rotation + ' ' + radius + ' ' + radius + ')'"></path>
      <circle v-bind:cx="radius" v-bind:cy="radius" v-bind:r="0.14 * radius" v-bind:fill="textColor"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "barometer",
  props: ["value", "colors", "textColor", "backgroundColor", "width", "height"],
  data: function () {
    return {
      radius: 50,
      range: 266
    }
  },
  computed: {
    paths: function () {
      var colorsLength = this.colors.length;
      var start = -1 * this.range / 2;
      var size = this.range / colorsLength;
      var result = [];
      for (var i = 0; i < colorsLength; i++) {
        var curr = start + (size * i);
        var x1 = this.sin(curr) * this.radius;
        var y1 = this.cos(curr) * this.radius;
        var x2 = this.sin(curr + size) * this.radius;
        var y2 = this.cos(curr + size) * this.radius;
        result.push({
          color: this.colors[i],
          d: "M " + x1 + " " + y1 + " A " + this.radius + " " + this.radius + " 0 " + (colorsLength == 1 ? 1 : 0) + " 1 " + x2 + " " + y2 + " L " + this.radius + " " + this.radius + " Z"
        });
      }
      return result;
    },
    path: function () {
      var x1 = this.radius;
      var y1 = this.radius * 0.92;
      var x2 = this.radius * 1.8;
      var y2 = this.radius * 0.98;
      var x3 = x2;
      var y3 = this.radius * 1.02;
      var x4 = x1;
      var y4 = this.radius * 1.08;
      return "M " + x1 + " " + y1 + " L " + x2 + " " + y2 + " L " + x3 + " " + y3 + " L " + x4 + " " + y4 + " Z";
    },
    rotation: function () {
      var base = this.value;
      if (base < 1) {
        base = 1;
      } else if (base > 100) {
        base = 100;
      }
      return ((base / 100) * this.range) - ((this.range / 2) + 90);
    }
  },
  methods: {
    sin: function (degrees) {
      return Math.sin(this.radian(degrees)) + 1;
    },
    cos: function (degrees) {
      return -1 * (Math.cos(this.radian(degrees)) - 1);
    },
    radian: function (degrees) {
      return degrees * (Math.PI / 180);
    }
  }
}
</script>
